import { useMemo } from "react";

/** Search + status filtering for AdminMessages. Pure derivation. */
export default function useMessageFilters(rows, q, statusFilter) {
    return useMemo(() => {
        const ql = q.toLowerCase();
        return rows.filter((r) => {
            if (statusFilter !== "all" && (r.status || "new") !== statusFilter) return false;
            if (!ql) return true;
            return (
                r.name?.toLowerCase().includes(ql) ||
                r.email?.toLowerCase().includes(ql) ||
                r.subject?.toLowerCase().includes(ql) ||
                r.message?.toLowerCase().includes(ql)
            );
        });
    }, [rows, q, statusFilter]);
}
